export default __webpack_public_path__ + "static/media/07-lifestyle_thumb.99a5dda9.png";